import type { MyFilesBreadcrumb } from "@nlc/shared-types";

import { useSearch } from "@tanstack/react-router";

import {
  Breadcrumb,
  Breadcrumbs as BreadcrumbsComponent,
} from "@/components/breadcrumbs";
import { useIsMyFileTemplate } from "@/features/my-files/hooks/useIsMyFileTemplate.tsx";
import { useIsMobileScreen } from "@/hooks/useIsMobileScreen";

interface BreadcrumbsProps {
  breadcrumbs: MyFilesBreadcrumb[];
  onLinkClick?: VoidFunction;
}

export function Breadcrumbs({ breadcrumbs, onLinkClick }: BreadcrumbsProps) {
  const isMobile = useIsMobileScreen();
  const isTemplate = useIsMyFileTemplate();
  const { requestType } = useSearch({ strict: false });

  const buildSearchParams = (index: number) => {
    const params: Record<string, number | string> = {};

    for (let i = 0; i <= index; i++) {
      const item = breadcrumbs[i];

      if (!item) continue;

      switch (item.slug) {
        case "account": {
          params.projectId = item.id;
          break;
        }
        case "brand": {
          params.brandId = item.id;
          break;
        }
        case "requestType": {
          params.requestType = item.id;
          break;
        }
        case "request": {
          params.requestId = item.id;
          break;
        }
        case "folder": {
          params.folder = item.id;
          break;
        }
      }
    }

    return params;
  };

  if (breadcrumbs.length === 0) return null;

  const lastItemIndex = breadcrumbs.length - 1;

  //We are sure, there is at least one breadcrumb here
  const mobileBreadcrumbs = [breadcrumbs[lastItemIndex]!];

  return (
    <BreadcrumbsComponent>
      {(isMobile ? mobileBreadcrumbs : breadcrumbs).map((item, index) => (
        <Breadcrumb
          key={item.slug + item.id}
          onLinkClick={onLinkClick}
          search={isTemplate ? { requestType } : buildSearchParams(index)}
          to={
            isTemplate
              ? "/my-files/template"
              : index === lastItemIndex
                ? undefined
                : "/my-files"
          }
        >
          {item.label}
        </Breadcrumb>
      ))}
    </BreadcrumbsComponent>
  );
}
